import React, {useEffect, useState} from "react";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import useCreatePasswordApi from "../../Global/Api/CreatePassword/createPasswordApi";
import usePasswordValidation from "../../Global/Hooks/passwordValidation";
import usePasswordToggle from "../../Global/Hooks/togglePassword";
import CreatePasswordScreen from "./render";
import showToast from "../../Global/Hooks/toast";

export default function CreatePassword() {
  const navigate = useNavigate();
  const location = useLocation();

  const createPasswordApi = useCreatePasswordApi();
  const passwordValidation = usePasswordValidation();
  const passwordConfirmValidation = usePasswordValidation();
  const passwordToggle = usePasswordToggle();
  const passwordConfirmToggle = usePasswordToggle();
  const [member_uid, setMemberUid] = useState('')
  const [password_token, setPasswordToken] = useState('')
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    let member = searchParams.get('member_uid')
    let token = searchParams.get('password_token')
    if (member) {
      localStorage.setItem('member_uid', member_uid)
      localStorage.setItem('password_token', password_token)
      setMemberUid(member);
      setPasswordToken(token);
      createPasswordApi.checkToken({member_uid: member, password_token: token})
    }
    if (localStorage.getItem("techsbook_customer_portal_token")?.length > 0) {
      navigate("/");
    }
  }, [])

  const handleSubmit = (event) => {
    event.preventDefault();
    if(member_uid) {
      const sendData =
        location?.state?.method === "signup"
          ? {
            password_confirmation: passwordConfirmValidation.value,
            password: passwordValidation.value,
          }
          : {
            password: passwordValidation.value,
            password_confirmation: passwordConfirmValidation.value,
          };
      createPasswordApi.sendWithToken({...sendData, member_uid, password_token});
    } else {
      if(!location.state?.member_uid || !location.state?.password_token ) {
        showToast('Need to verify email first, then you can create password!', "error");
        navigate("/register");
      } else {
        const sendData =
          location?.state?.method === "signup"
            ? {
              password_confirmation: passwordConfirmValidation.value,
              password: passwordValidation.value,
            }
            : {
              password: passwordValidation.value,
              password_confirmation: passwordConfirmValidation.value,
            };
        createPasswordApi.send(sendData);
      }
    }

  };

  const handlePasswordChange = (event) => {
    passwordValidation.handleChange(event);
  };

  const handlePasswordConfirmChange = (event) => {
    passwordConfirmValidation.handleChange(event);
  };

  const comparePasswords = () => {
    return (
      passwordValidation.value === passwordConfirmValidation.value &&
      passwordValidation.value.length > 0
    );
  };

  const isButtonDisabled = !(
    passwordValidation.isValid &&
    passwordConfirmValidation.isValid &&
    comparePasswords()
  );

  return (
    <CreatePasswordScreen
      passwordValidation={passwordValidation}
      passwordConfirmValidation={passwordConfirmValidation}
      handleSubmit={handleSubmit}
      passwordToggle={passwordToggle}
      handlePasswordChange={handlePasswordChange}
      passwordConfirmToggle={passwordConfirmToggle}
      handlePasswordConfirmChange={handlePasswordConfirmChange}
      isButtonDisabled={isButtonDisabled}
    />
  );
}
